import { Logo } from '@/components/brand/Logo'

interface LoadingStateProps {
  message?: string
  subMessage?: string
}

export function LoadingState({ message = 'Loading…', subMessage }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <div className="relative">
        <Logo variant="icon" size="lg" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full border-2 border-signal-cyan/30 animate-ripple" />
        </div>
      </div>
      <p className="text-sm font-medium text-deep-ink">{message}</p>
      {subMessage && <p className="text-xs text-slate-500">{subMessage}</p>}
    </div>
  )
}

export function EnsembleLoader({ step, total }: { step: number; total: number }) {
  const steps = [
    'Parsing study…',
    'Building Study Memory…',
    'Running ensemble pass 1 of 7: Evidence Grounded…',
    'Running ensemble pass 2 of 7: Segment Response…',
    'Running ensemble pass 3 of 7: Skeptical Researcher…',
    'Running ensemble pass 4 of 7: Behavioral Driver…',
    'Running ensemble pass 5 of 7: Counterfactual Risk…',
    'Running ensemble pass 6 of 7: Quantitative Distribution…',
    'Running ensemble pass 7 of 7: Validation Planner…',
    'Aggregating confidence…',
    'Generating report…',
  ]

  return (
    <div className="flex flex-col items-center gap-6 py-12">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-2 border-human-teal/20 animate-ripple" />
        <div className="absolute inset-2 rounded-full border-2 border-signal-cyan/40 animate-ripple" style={{ animationDelay: '0.3s' }} />
        <div className="absolute inset-4 flex items-center justify-center">
          <div className="w-5 h-5 bg-human-teal rounded-full animate-pulse-teal" />
        </div>
      </div>
      <div className="text-center space-y-1">
        <p className="text-sm font-medium text-deep-ink">{steps[Math.min(step, steps.length - 1)]}</p>
        <p className="text-xs text-slate-400">{step} of {total} steps</p>
      </div>
      <div className="w-48 h-1.5 bg-soft-panel rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-human-teal to-signal-cyan rounded-full transition-all duration-500"
          style={{ width: `${(step / total) * 100}%` }}
        />
      </div>
    </div>
  )
}
